module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"logout":"Sign-out","language":"Change language","configuration":"Configure your account"},"fr_FR":{"logout":"Se déconnecter","language":"Changer de langue","configuration":"Configurer votre compte"}}')
  delete Component.options._Ctor
}
